module.exports = __webpack_public_path__ + "static/media/core2.0ee8a5ce.png";